<template>
  <b-row>
    <!-- Customer -->
    <b-col cols="12" md="4" class="mb-md-0 mb-2">
      <label>Customer</label>
      <customer-dropdown-filter
        id="customerIDFilter"
        placeholder="Enter Customer ID"
        :value="customerIDFilter"
        @input="(val) => $emit('update:customer-id-filter', val)"
      />
    </b-col>
    <!-- Sales Type -->
    <b-col cols="12" md="4" class="mb-md-0 mb-2">
      <label>Sales Type ID</label>
      <sales-type-dropdown-filter
        id="salesTypeIDFilter"
        placeholder="Enter Sales Type ID"
        :value="salesTypeIDFilter"
        @input="(val) => $emit('update:sales-type-id-filter', val)"
      />
    </b-col>
    <!-- FBR Invoice Number -->
    <b-col cols="12" md="4" class="mb-md-0 mb-2">
      <label>FBR Invoice Number</label>
      <b-form-input
        id="fbrInvoiceNumberFilter"
        placeholder="Enter FBR Invoice Number"
        :value="fbrInvoiceNumberFilter"
        @input="(val) => $emit('update:fbr-invoice-number-filter', val)"
      />
    </b-col>
    <!-- Is Active -->
    <b-col cols="12" md="2" class="mb-md-0 mb-2">
      <label>Is Active</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="isActiveFilter"
        :options="isActiveOptions"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:is-active-filter', val)"
      />
    </b-col>
    <!-- FBR Status -->
    <b-col cols="12" md="2" class="mb-md-0 mb-2">
      <label>FBR Status</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="fbrStatusFilter"
        :options="fbrStatusOptions"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:fbr-status-filter', val)"
      />
    </b-col>
    <!-- Date filters -->
    <b-col cols="12" md="4" class="mb-md-0 mb-2">
      <label>Sale Date From</label>
      <flat-pickr
        id="saleDateFromFilter"
        class="form-control"
        :value="saleDateFrom"
        placeholder="mm/dd/yyyy"
        @input="(val) => $emit('update:sale-date-from', val)"
      />
    </b-col>
    <b-col cols="12" md="4" class="mb-md-0 mb-2">
      <label>Sale Date To</label>
      <flat-pickr
        id="saleDateToFilter"
        class="form-control"
        :value="saleDateTo"
        placeholder="mm/dd/yyyy"
        :config="{ minDate: saleDateFrom || null }"
        @input="(val) => $emit('update:sale-date-to', val)"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput } from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import CustomerDropdownFilter from '@/views/apps/fbr-invoice/components/filters/CustomerDropdownFilter.vue';
import SalesTypeDropdownFilter from '@/views/apps/fbr-invoice/components/filters/SalesTypeDropdownFilter.vue';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr,
    BFormInput,
    CustomerDropdownFilter,
    SalesTypeDropdownFilter,
  },
  props: {
    isActiveFilter: {
      type: Array,
      default: null,
    },
    fbrStatusFilter: {
      type: Array,
      default: null,
    },
    customerIDFilter: {
      type: [String, null],
      default: null,
    },
    salesTypeIDFilter: {
      type: [String, null],
      default: null,
    },
    fbrInvoiceNumberFilter: {
      type: [String, null],
      default: null,
    },
    saleDateFrom: {
      type: [String, null],
      default: null,
    },
    saleDateTo: {
      type: [String, null],
      default: null,
    },
  },
  data() {
    return {
      fbrStatusOptions: [
        { value: null, label: 'All' },
        { value: 'Invalid', label: 'Invalid' },
        { value: 'pending', label: 'Pending' },
        { value: 'posted', label: 'Posted' },
      ],
      isActiveOptions: [
        { value: null, label: 'All' },
        { value: true, label: 'Active' },
        { value: false, label: 'Inactive' },
      ],
    };
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
